function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.921 20.575a8 8 0 1 0-8-8 8.05 8.05 0 0 0 8 8zm0-1.572a6.424 6.424 0 1 1 6.428-6.428A6.405 6.405 0 0 1 12.921 19zm-.178-4.887a.645.645 0 0 0 .72-.558v-.093c.023-.4.3-.674.805-1 .759-.5 1.255-.945 1.255-1.843 0-1.293-1.162-2.029-2.532-2.029a2.44 2.44 0 0 0-2.47 1.332 1.192 1.192 0 0 0-.07.4.6.6 0 0 0 .6.6.722.722 0 0 0 .627-.325l.124-.155A1.227 1.227 0 0 1 12.9 9.8a.939.939 0 0 1 1.053.9c0 .488-.325.728-.984 1.185a1.748 1.748 0 0 0-.953 1.487v.085c-.001.435.262.659.727.659zm-.008 2.378a.85.85 0 1 0-.906-.852.872.872 0 0 0 .906.852z",
  transform: "translate(-4.921 -4.575)"
});

function SvgQuestionOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOutline);
export default __webpack_public_path__ + "static/media/question_outline.4443ef7e.svg";
export { ForwardRef as ReactComponent };